import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flexcol _jc-c" }
const _hoisted_2 = {
  "format-key": "0",
  "data-qa": "project-order-card-publicOrderID"
}
const _hoisted_3 = { "format-key": "1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_backer_center_thumbnail = _resolveComponent("backer-center-thumbnail")
  const _component_base_text = _resolveComponent("base-text")
  const _component_localize = _resolveComponent("localize")
  const _component_backer_center_header = _resolveComponent("backer-center-header")

  return (_openBlock(), _createBlock(_component_backer_center_header, null, {
    prefix: _withCtx(() => [
      _createVNode(_component_backer_center_thumbnail, {
        "image-url": $props.imageUrl,
        name: $props.name,
        url: $options.formattedYourPledgeUrl
      }, null, 8 /* PROPS */, ["image-url", "name", "url"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_base_text, {
          as: "a",
          href: $options.formattedYourPledgeUrl,
          level: "b1",
          class: "_toe",
          title: $props.name,
          "data-qa": "project-order-card-projectName"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.name), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["href", "title"]),
        _createVNode(_component_localize, {
          tag: "div",
          resource: $options.captionResource,
          class: "_tc--light gfu-bt--caption"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_2, _toDisplayString($props.orderPublicID), 1 /* TEXT */),
            _createElementVNode("span", _hoisted_3, _toDisplayString($options.formattedCreatedAt), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["resource"])
      ])
    ]),
    suffix: _withCtx(() => [
      _createVNode(_component_base_text, {
        level: "b1",
        class: "_as-fs",
        "data-qa": "project-order-card-TotalAmount"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.formattedTotalAmount), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}